module.exports = __webpack_public_path__ + "media/components/blocks/ExploreAndDiscover/arrow_up-07ce242b967b61ebcd95a9a142f30a87.png";